import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Executive, PersonalityTypes } from 'Types/PersonTypes';
import { backgroundColorParsing, isXiqUser } from 'Utils/UtilityFunctions';
import { useDispatch } from 'react-redux';
import { actions as peopleFollowActions } from 'Slice/PeopleFollowSlice';
import { usePrevious } from 'Utils/hooks/usePrevious';
import { useNavigate } from 'react-router-dom';
import DrawerPeopleMoveReason from 'Components/people/components/DrawerPeopleMoveReason';
import classNames from 'classnames';
import { PERSONALITY_INSIGHTS_ROUTE } from 'Utils/Constants';
import { Dropdown } from 'antd';
import {
  primaryFont, secondaryFont, wLight,
  wMedium, primaryColor, boxShadow, primaryHeadingColor, maxWidth, retina,
} from '../../../Utils/utilsStyle';
import SmallButton from './SmallButton';
import PeopleWidgetWithOutHolo from './PeopleWidgetWithOutHolo';

type Props = {
  executive?: Executive,
  disableNavigation?: boolean,
  openInNewTab?: boolean,
  personName?: string
  logo?: string
  persona?: string
  tag?: string
  executiveType?: string,
  personAddedFlag?: boolean
  personId?: number
  companyName?: string
  personalityTypesColors?: PersonalityTypes[]
  wrapperColor?: string
  showDrawerIcon?: boolean
} & typeof defaultProps;

const defaultProps = {
  executive: {},
  disableNavigation: false,
  openInNewTab: false,
  persona: '#979797',
  logo: 'https://picsum.photos/200',
  personName: '',
  tag: '',
  companyName: '',
  executiveType: '',
  wrapperColor: '#979797',
  personId: 0,
  personAddedFlag: false,
  showDrawerIcon: false,
  personalityTypesColors: [{
    description: '',
    color: '',
    image: '',
    key: '',
    value: '',
    cardColor: '',
  }],
};

const Wrapper = styled.div<{ color: string, wrapperColor: string }>`
  width:100%;
  background-color:#FFFFFF;
  border-radius:10px;
  box-shadow:${boxShadow};
  padding:18px 15px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    padding: 10px 15px;
  }
  .small-button-chinese {
    height: 30px;
    padding: 4px 12px !important;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      height: 24px;
    }
  }
  .action-btn {
    align-items: center;
  }
  &.iconDrawerStyle {
    .action-btn {
      align-items: center;
      .drawerAction {
        position: relative;
        right: 0px;
        top: 1px;
        margin-right: 5px;
        display: inline-block;
      }
      
    }
  }
  .left-profile{
    cursor: pointer;
  }
  .details{
    padding-left:15px;
    .designation{
      color:${primaryColor};
      font-size:14px;
      font-weight:${wMedium};
      font-family: ${primaryFont};
      margin:0;
      @media all and (max-width: ${maxWidth}) , ${retina} {
       font-size: 12px;
      }
    }
    .name{
      color:#000;
      font-size:20px;
      font-weight:${wLight};
      font-family: ${secondaryFont};
      margin:0;
      line-height:24px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
       font-size: 16px;
      }
    }
    .company{
      color:${primaryHeadingColor};
      font-size:14px;
      font-weight:${wMedium};
      font-family: ${primaryFont};
      margin:0;
      @media all and (max-width: ${maxWidth}) , ${retina} {
       font-size: 12px;
      }
    }
  }
  .user-image{
    > div{
      /* padding: 2px !important; */
      margin-bottom:0;
    }
  }
  button{
    padding:7px 12px !important;
    font-size: 10px;
    /* &[title="Unfollow"]{
      padding: 4px 7px !important;
    } */// due to global button changes
  }
  .dropdown{
    padding-left:10px;
    cursor: pointer;
    svg{
      vertical-align: text-top;
    }
  }
`;

const PeopleCardList = function PeopleCardList(props: Props) {
  const {
    executive, disableNavigation, openInNewTab,
    logo, persona, tag, personAddedFlag, personId, executiveType,
    personName, personalityTypesColors, companyName, wrapperColor, showDrawerIcon,
  } = props;
  const navigate = useNavigate();
  const [buttonClicked, setButtonClicked] = useState<boolean>(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState<boolean>(false);
  const dispatch = useDispatch();
  const perviousExecutive = usePrevious(executive);

  useEffect(() => {
    if (perviousExecutive?.personAdded !== personAddedFlag && buttonClicked) {
      setButtonClicked(false);
    }
  }, [executive]);

  const handleFollowPerson = () => {
    setButtonClicked(true);
    let obj = {};
    if (!personAddedFlag) {
      obj = {
        person_data: [{
          type: executiveType,
          query: personName,
          entity_id: personId,
        }],
      };
    } else {
      obj = {
        feedids: [personId],
        type: executiveType,
      };
    }
    dispatch(peopleFollowActions.updateProfileFollow(obj));
  };

  const navigateTo = () => {
    if (!disableNavigation) {
      let url = '';
      if (personId) url = `${PERSONALITY_INSIGHTS_ROUTE}${personId}&personType=${executiveType}`;
      if (url?.length) {
        if (url?.length) {
          if (openInNewTab) window.open(url);
          else navigate(url);
        }
      }
    }
  };

  const items = [
    {
      label:
        <span
          role="button"
          tabIndex={0}
          onClick={() => {
            if (isDropdownVisible) {
              setIsDropdownVisible(false);
              window.open(`${PERSONALITY_INSIGHTS_ROUTE}${personId}&personType=${executiveType}`, '_blank');
            } else {
              navigateTo();
            }
          }}
          onKeyPress={() => {
            if (isDropdownVisible) {
              setIsDropdownVisible(false);
              window.open(`${PERSONALITY_INSIGHTS_ROUTE}${personId}&personType=${executiveType}`, '_blank');
            } else {
              navigateTo();
            }
          }}
          aria-label="redirectCard"
        >
          Open in New Tab
        </span>,
      key: '1',
    },
  ];

  const handleWidgetClick = () => {
    if (!isXiqUser()) return;
    setIsDropdownVisible((prev) => !prev);
  };

  return (
    <Wrapper
      color={persona}
      wrapperColor={wrapperColor}
      className={classNames({ iconDrawerStyle: showDrawerIcon })}
    >
      <div className="d-flex align-self-center justify-content-between">
        <Dropdown
          menu={{ items }}
          trigger={['contextMenu']}
          visible={isDropdownVisible}
          onOpenChange={handleWidgetClick}
        >
          <div
            className="left-profile d-flex justify-content-center align-self-center"
            onClick={navigateTo}
            onKeyPress={navigateTo}
            tabIndex={0}
            role="button"
            aria-label="View person information"
          >
            <div className="user-image  d-flex align-self-center">
              <PeopleWidgetWithOutHolo
                logo={logo}
                persona={persona}
                diameter="54px"
                diameterSm="54px"
                diameterXsm="54px"
                wrapperColor={backgroundColorParsing(personalityTypesColors)}
                ringPadding="3px"
                ringPaddingSm="3px"
              />
            </div>
            <div className="details">
              <h5 className="name text-truncate-one-line">
                {personName}
              </h5>
              <p className="company text-truncate-one-line">
                {companyName}
              </p>
              <p className="designation text-truncate-one-line">
                {tag}
              </p>
            </div>
          </div>
        </Dropdown>
        <div className="d-flex justify-content-center action-btn">
          {showDrawerIcon && (
            <DrawerPeopleMoveReason personId={personId} showNotes isPersonCard />
          )}
          <SmallButton
            title={!personAddedFlag ? 'Follow' : 'Unfollow'}
            variant={!personAddedFlag ? 'filled' : 'outlined'}
            color="#001760"
            onButtonClick={() => handleFollowPerson()}
            disabled={buttonClicked}
          />
        </div>
      </div>
    </Wrapper>
  );
};

PeopleCardList.defaultProps = defaultProps;
export default React.memo(PeopleCardList);
